export default __webpack_public_path__ + "static/media/factory__18.51ac166e.jpg";